<div class="modal-header">
  <button
    type="button"
    (click)="onClick(false)"
    class="close"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>

  <h3 class="modal-title">
    <strong>Atenção!</strong>
  </h3>
</div>

<div class="modal-body text-center">
  <span class="icon warning icone-laranja"></span>
  <h4 class="margin">O cliente iniciou a etapa de autenticação!</h4>
  <h4>
    Se preferir
    <strong
      >inicie o processo de Autenticação do cliente – Validação de celular e
      Biometria manual.
    </strong>
  </h4>

  <h4 class="text-danger">
    <strong
      >Lembre-se que esta etapa é obrigatória e não será possível formalizar a
      proposta sem a autenticação do cliente.
    </strong>
  </h4>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-full-orange" (click)="onClick(false)">
    Aguardar o cliente
  </button>

  <button type="button" class="btn btn-border-orange" (click)="onClick(true)">
    Iniciar processo manual
  </button>
</div>
